import { useState } from 'react';
import './WelcomeModal.css';

const STORAGE_KEY = 'indyanna_welcome_done_v1';

export function hasSeenWelcome(): boolean {
  try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
}

const STEPS = [
  {
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="6" y="10" width="36" height="28" rx="4" fill="rgba(239,114,24,0.15)" stroke="#ef7218" strokeWidth="2"/>
        <rect x="12" y="16" width="10" height="10" rx="2" fill="#ef7218" opacity="0.7"/>
        <rect x="26" y="16" width="10" height="10" rx="2" fill="#ef7218" opacity="0.4"/>
        <rect x="12" y="30" width="24" height="3" rx="1.5" fill="#ef7218" opacity="0.3"/>
      </svg>
    ),
    title: 'Choisissez un design',
    desc: 'Parcourez notre galerie et appliquez un design en un clic.',
  },
  {
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="24" cy="24" r="16" fill="rgba(239,114,24,0.12)" stroke="#ef7218" strokeWidth="2"/>
        <circle cx="17" cy="22" r="5" fill="#ef7218" opacity="0.7"/>
        <circle cx="30" cy="18" r="5" fill="#1b1c15" opacity="0.5"/>
        <circle cx="26" cy="31" r="5" fill="rgba(239,114,24,0.5)"/>
      </svg>
    ),
    title: 'Couleurs & motifs',
    desc: 'Changez les couleurs et habillez votre produit d\'un motif répété.',
  },
  {
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="8" y="14" width="20" height="20" rx="3" fill="rgba(239,114,24,0.15)" stroke="#ef7218" strokeWidth="2"/>
        <path d="M14 24h8M14 29h5" stroke="#ef7218" strokeWidth="2" strokeLinecap="round"/>
        <rect x="30" y="20" width="12" height="14" rx="2" fill="#ef7218" opacity="0.2" stroke="#ef7218" strokeWidth="1.5"/>
        <path d="M33 27h6M33 30h4" stroke="#ef7218" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Logos & textes',
    desc: 'Importez votre logo, ajoutez noms, numéros ou slogans.',
  },
  {
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M24 8v20M16 20l8 8 8-8" stroke="#ef7218" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="8" y="32" width="32" height="8" rx="3" fill="rgba(239,114,24,0.15)" stroke="#ef7218" strokeWidth="2"/>
        <circle cx="35" cy="36" r="2" fill="#ef7218"/>
      </svg>
    ),
    title: 'Envoyez pour un devis',
    desc: 'Partagez votre création à notre équipe et recevez un devis personnalisé.',
  },
];

type Props = {
  onClose: () => void;
};

export default function WelcomeModal({ onClose }: Props) {
  const [noShow, setNoShow] = useState(false);
  const [visible, setVisible] = useState(true);

  function handleStart() {
    if (noShow) {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* noop */ }
    }
    setVisible(false);
    setTimeout(onClose, 280);
  }

  return (
    <div className={`welcome-overlay ${visible ? 'welcome-overlay--in' : 'welcome-overlay--out'}`} role="dialog" aria-modal="true" aria-label="Bienvenue sur Indyanna Studio">
      <div className="welcome-backdrop" onClick={handleStart} />
      <div className="welcome-card">
        <div className="welcome-header">
          <div className="welcome-logo-wrap">
            <img src="/assets/IndyannaStudio_Logo.png" alt="Indyanna Studio" className="welcome-logo" />
            <div className="welcome-logo-orange" aria-hidden="true" />
          </div>
          <h2 className="welcome-title">Bienvenue sur Indyanna Studio</h2>
          <p className="welcome-subtitle">
            Créez facilement vos vêtements personnalisés. Ajoutez vos motifs, logos, couleurs et textes, puis envoyez votre création pour obtenir un devis.
          </p>
        </div>

        <div className="welcome-steps">
          {STEPS.map((step, i) => (
            <div className="welcome-step" key={i}>
              <div className="welcome-step-icon">{step.icon}</div>
              <div className="welcome-step-body">
                <div className="welcome-step-number">{i + 1}</div>
                <strong className="welcome-step-title">{step.title}</strong>
                <p className="welcome-step-desc">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="welcome-footer">
          <button type="button" className="welcome-cta" onClick={handleStart}>
            Commencer la personnalisation
          </button>
          <label className="welcome-noshow">
            <input
              type="checkbox"
              checked={noShow}
              onChange={e => setNoShow(e.target.checked)}
            />
            <span>Ne plus afficher</span>
          </label>
        </div>
      </div>
    </div>
  );
}
